import type { Profile } from '@here/api'
import { debounce } from '@solid-primitives/scheduled'
import { createResource, createSignal } from 'solid-js'
import { getProfiles } from './resources/getProfiles'

export function useMention() {
	const [searchTerm, setSearchTerm] = createSignal('')
	const [activeMentions, setActiveMentions] = createSignal<Profile[]>([])
	const [profilesResource] = createResource(searchTerm, getProfiles)

	return {
		searchTerm,
		setSearchTerm: debounce(setSearchTerm, 300),
		profilesResource,
		activeMentions,
		setActiveMentions,
	}
}
